import api from "src/api/axios";

const createVehicle = async (input) => {
  return api.post(`/vehicle`, input).then((result) => {
    return result.data;
  });
};



const updateVehicle = async (input, id) => {
  return api.patch(`/vehicle/${id}`, input).then((result) => {
    return result.data;
  });
};



const getVehicleList = async ({
  limit,
  page,
  region = "",
  registrationNo
}) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  if (region) params.append("region", region);
  if (registrationNo) params.append("registrationNo", registrationNo);
  // if (searchParmas) {
  //   Object.keys(searchParmas).map((item) => {
  //     if (searchParmas[item]) {
  //       params.append(item, searchParmas[item]);
  //     }
  //   });
  // }
  // if (q) params.append("q", q);
  return api.get(`/vehicle?${params}`).then((result) => {
    return result.data;
  });
};

const getSearchablevehicleList = async ({ country }) => {
  const params = new URLSearchParams();
  if (country) params.append("country", country);
  return api.get(`/vehicle/list?${params}`).then((result) => {
    return result.data;
  });
};


const getSingleVehicle = async (id) => {
  return api.get(`/vehicle/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createVehicle,
  getVehicleList,
  getSingleVehicle,
  updateVehicle,
  getSearchablevehicleList,
};
